function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "OTP_Illustration",
  transform: "translate(0)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_1047",
  transform: "translate(7641.73 880.51)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1591",
  d: "M370,270.07c-26.25-5.53-46.25-24.95-57.85-56.18a163,163,0,0,1-9.43-43.68l-.45-8.91,70.2-24.81,70.19,24.81-.45,8.91a162.309,162.309,0,0,1-9.42,43.68c-11.6,31.23-31.61,50.65-57.86,56.18l-2.46.52Z",
  transform: "translate(-7944 -1017)",
  fill: "#fec22d"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1592",
  d: "M428.08,170.91l-55.6-19.65h0l-55.6,19.65s3.76,74.46,55.6,85.38h0C424.31,245.37,428.08,170.91,428.08,170.91Z",
  transform: "translate(-7944 -1017)",
  fill: "#fece57"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1728",
  d: "M3.02,0H61.65a3.02,3.02,0,0,1,3.02,3.02V16.95a3.02,3.02,0,0,1-3.02,3.02H3.02A3.02,3.02,0,0,1,0,16.95V3.02A3.02,3.02,0,0,1,3.02,0Z",
  transform: "translate(-7553 -856.24)",
  fill: "#0a54a6"
}), /*#__PURE__*/React.createElement("g", {
  id: "Group_1046",
  transform: "translate(2.01)"
}, /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_257",
  cx: 1.83,
  cy: 1.83,
  r: 1.83,
  transform: "translate(-7527.87 -847.48)",
  fill: "#fec22d"
}), /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_258",
  cx: 1.83,
  cy: 1.83,
  r: 1.83,
  transform: "translate(-7520.89 -847.48)",
  fill: "#fec22d"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1635",
  d: "M433.75,171.35a1.83,1.83,0,1,1-1.83-1.83,1.83,1.83,0,0,1,1.83,1.83Z",
  transform: "translate(-7944 -1017)",
  fill: "#fec22d"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1636",
  d: "M440.73,171.35a1.83,1.83,0,1,1-1.83-1.83,1.83,1.83,0,0,1,1.83,1.83Z",
  transform: "translate(-7944 -1017)",
  fill: "#fec22d"
}), /*#__PURE__*/React.createElement("g", {
  id: "Group_1045",
  transform: "translate(655 -277.711)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1690",
  d: "M102.283,138.575l-7.242-.015a1.027,1.027,0,0,0-1.027,1.021L93.99,151.93a1.028,1.028,0,0,0,1.022,1.027l7.242.014a1.024,1.024,0,0,0,1.025-1.021L103.3,139.6A1.027,1.027,0,0,0,102.283,138.575Z",
  transform: "translate(-8292 -714)",
  fill: "#89caf7"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1691",
  d: "M109.345,146.272h-.795a.2.2,0,0,0-.166.089l-.187.282a1.045,1.045,0,0,1-.874.468l-3.073-.006a1.049,1.049,0,0,1-.872-.472l-.186-.283a.2.2,0,0,0-.167-.09h-.794a.2.2,0,0,0-.2.2l-.029,12.3a.2.2,0,0,0,.2.2l7.115.015a.2.2,0,0,0,.2-.2l.023-12.3a.2.2,0,0,0-.194-.2Z",
  transform: "translate(-8299.126 -720.851)",
  fill: "#d2ebff"
})))));

var SvgOtp = function SvgOtp(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 153.4,
    height: 134.1,
    viewBox: "0 0 153.4 134.1",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgOtp, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/otp.6c9a88a4.svg";
export { ForwardRef as ReactComponent };